"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_classValue = require("marko/dist/runtime/helpers/class-value"),
    marko_component = {
        onCreate: function() {
          GState.bind(this, [
              "tenant",
              "theme"
            ]);
        },
        onSocialSignin: function(provider) {
          if (!this.input.token) {
            return;
          }

          document.location = (("/" + provider) + "/") + this.input.token;
        }
      },
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/components/SSOAuth.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    module_SSOPs = require("json/SSOPs"),
    SSOPs = module_SSOPs.default || module_SSOPs,
    marko_forIn = require("marko/dist/runtime/helpers/for-in"),
    marko_loadNestedTag = require("marko/dist/runtime/helpers/load-nested-tag"),
    Row_col_nested_tag = marko_loadNestedTag("col", 1),
    marko_mergeNestedTagsHelper = require("marko/dist/runtime/helpers/merge-nested-tags"),
    Row_template = require("../../components/Row/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Row_tag = marko_loadTag(Row_template),
    marko_attrs0 = {
        "class": "d-flex align-items-center cursor-pointer border rounded"
      },
    marko_attrs1 = {
        "class": "d-block w-75 text-center font-medium-3"
      };

function render(input, out, __component, component, state) {
  var data = input;

  if ((state.tenant && state.tenant.settings.SSO) && state.tenant.settings.SSO.enabled) {
    Row_tag(marko_mergeNestedTagsHelper({
        class: "m-0",
        renderBody: function(out, $nestedTagRow$0) {
          var $for$0 = 0;

          marko_forIn(SSOPs, function(name, { label, icon, def }) {
            var $keyScope$0 = "[" + (($for$0++) + "]");

            const providers = state.tenant && state.tenant.settings.SSO && state.tenant.settings.SSO.providers || []

            if ((def && providers.includes(name)) || ((input.excepts && Array.isArray(input.excepts)) && input.excepts.includes(name))) {
              Row_col_nested_tag({
                  class: marko_classValue([
                    "p-50",
                    providers.length > 1 ? "col-md-6" : "col"
                  ]),
                  renderBody: function(out) {
                    out.e("div", marko_attrs0, "2" + $keyScope$0, component, 2, 0, {
                        onclick: __component.d("click", "onSocialSignin", false, [
                            name
                          ])
                      })
                      .e("i", {
                          "class": marko_classValue(marko_classValue([
                            "font-large-1 p-1",
                            ((icon + " ") + (state.theme.mode == "dark" ? "white" : "black")) + "-text"
                          ]))
                        }, "3" + $keyScope$0, component, 0, 1)
                      .e("div", marko_attrs1, "4" + $keyScope$0, component, 1)
                        .t(label, component);
                  }
                }, $nestedTagRow$0);
            }
          });
        }
      }), out, __component, "0");
  }
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
